const kk = {
  loadingTypes: {
    notSpecified: 'белгіленбеген',
  },
};

export { kk };
